import { DELETE, GET, POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/products/${endpoint}`;
};

export const getVoucherThemes = (token, clientRef, page, limit) => {
  let endpoint = `all-products?featured=true&page=${page}&limit=${limit}`;
  if (clientRef) {
    endpoint += `&clientRef=${clientRef}`;
  }

  endpoint = getEndpointWithPrefix(endpoint);
  return GET(endpoint, token);
};

export const updateVoucherTheme = async (themeData, token, themeId) => {
  const endpoint = getEndpointWithPrefix(`update-product/${themeId}`);
  // POST signature: (endpoint, requestBody = {}, authorization = null)
  return POST(endpoint, themeData, token);
};
export const getAllProducts = (
  token,
  featured = undefined,
  published = undefined,
  page,
  limit,
  clientRef = false,
  searchKey = undefined
) => {
  // Build query params dynamically only when values are provided
  const params = [];
  if (featured !== undefined && featured !== null) params.push(`featured=${featured}`);
  if (published !== undefined && published !== null) params.push(`published=${published}`);
  if (clientRef !== undefined && clientRef !== false) params.push(`clientRef=${encodeURIComponent(clientRef)}`);
  if (searchKey !== undefined && searchKey !== null && searchKey.trim() !== '') params.push(`searchKey=${encodeURIComponent(searchKey)}`);
  params.push(`page=${page}`);
  params.push(`limit=${limit}`);
  params.push(`searchId=title`);
  params.push(`sortBy=id`);
  params.push(`sortDirection=desc`);

  const query = params.length ? `?${params.join('&')}` : '';
  const endpoint = `/products/all-products${query}`;
  return GET(endpoint, token);
};

export const addProduct = (productData, token) => {
  const endpoint = getEndpointWithPrefix('create');
  return POST(endpoint, productData, token);
}

export const getProductCategories = (token) => {
  const endpoint = getEndpointWithPrefix('product-category');
  return GET(endpoint, token);
};

export const updateProduct = (token, productId, productData) => {
  const endpoint = getEndpointWithPrefix(`update/${productId}`);
  return PUT(endpoint, productData, token);
};

export const deleteProduct = (token, productId) => {
  const endpoint = getEndpointWithPrefix(`delete/${productId}`);
  return DELETE(endpoint, {}, token);
};

export const searchProducts = (token, searchKey, page, limit) => {
  const endpoint = getEndpointWithPrefix(`search?page=${page}&limit=${limit}&searchKey=${searchKey}&published=true`);
  return GET(endpoint, token);
};

// Product Category APIs
export const getProductCategoriesList = (token, page, limit) => {
  const endpoint = getEndpointWithPrefix(`product-category?page=${page}&pageSize=${limit}&sortBy=id&sortDirection=asc`);
  return GET(endpoint, token);
};

export const addProductCategory = (categoryData, token) => {
  const endpoint = getEndpointWithPrefix('add-product-category');
  return POST(endpoint, categoryData, token);
};

export const updateProductCategory = (token, categoryId, categoryData) => {
  const endpoint = getEndpointWithPrefix(`update-product-category/${categoryId}`);
  return PUT(endpoint, categoryData, token);
};

export const searchProductCategories = (token, searchKey, searchId, page, limit, status) => {
  const params = [];
  // searchKey is required by backend, use empty string if not provided
  params.push(`searchKey=${encodeURIComponent(searchKey)}`);
  params.push(`page=${page}`);
  params.push(`pageSize=${limit}`);
  params.push(`sortBy=id`);
  params.push(`sortDirection=asc`);
  params.push(`searchId=${searchId}`)

  if (status) {
    params.push(`status=${encodeURIComponent(status)}`);
  }

  const query = `?${params.join('&')}`;
  const endpoint = getEndpointWithPrefix(`search-product-categories${query}`);
  return GET(endpoint, token);
};

export const searchProductCategoryDropdownList = (token, searchKey, searchId, sortBy, sortDirection) => {
  const endpoint = getEndpointWithPrefix(`get-dropdown-productCategories?searchKey=${encodeURIComponent(searchKey)}&searchId=${searchId}&sortBy=${sortBy}&sortDirection=${sortDirection}`);
  return GET(endpoint, token);
}